import { useState } from "react";
import { Box, Button, Text } from "@chakra-ui/react";
import { DownloadIcon } from "@chakra-ui/icons";
import { CustomToast } from "../../components";
import { useAuth } from "../../hooks/useAuth";
import { cardProps } from "./billingui";

const API_BASE = process.env.REACT_APP_API_URL ?? "https://localhost:7145/api";
const NAVY = "#0F2A5C";

interface Props {
  projectId: number;
  invoiceId: number;
  invoiceNumber?: string;
}

export default function InvoicePdfButtons({ projectId, invoiceId, invoiceNumber }: Props) {
  const { addToast } = CustomToast();
  const { loginObj } = useAuth();
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const token = (loginObj as any)?.token ?? localStorage.getItem("token"); // <- adjust to your storage key
      const res = await fetch(`${API_BASE}/projects/${projectId}/billing/${invoiceId}/pdf`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(String(res.status));

      const url = URL.createObjectURL(await res.blob());
      const a = document.createElement("a");
      a.href = url;
      a.download = `${invoiceNumber ?? "invoice"}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      addToast({ status: "error", message: "Could not download invoice PDF" });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box {...cardProps} p={3} h="100%">
      <Text fontSize="xs" color="gray.500">
        Latest invoice
      </Text>
      <Text fontSize="sm" fontWeight="bold" color={NAVY} mb={2} noOfLines={1}>
        {invoiceNumber ?? "-"}
      </Text>
      <Button size="sm" colorScheme="blue" leftIcon={<DownloadIcon />} isLoading={busy} loadingText="Downloading" onClick={download}>
        Download PDF
      </Button>
    </Box>
  );
}
